/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: false });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getTask(id) {
    return axios.get(`${this.url}/${id}`);
  }

  replayEvents(params = {}) {
    return axios.get(`${this.url}/events/replay`, { params });
  }
}

export default new TasksAPI();
